/* pf-cc-form.js v4 - custom-cushion buy box enhancement. Loaded only when template.suffix contains 'custom-cushion'.
   Presentation only: never clones/moves inputs, never sets values, never blocks add-to-cart (the colorcode
   block's validator stays the only blocker). Any error -> failOpen() restores the plain form. Kill switch: ?pf_cc_off=1
   v4 also neutralises the sticky bar's own variant pickers and the express checkout buttons (both hand the
   cart a variant the shopper never chose) and gives the required file field a form= owner so it reaches the
   order. Both are attribute-only and are undone by failOpen().
   v5 adds four things, all of them additive and all undone by failOpen(): a read-only name + price in the
   collapsed sticky bar (hiding the picker panel had left a phone with a buy button and no price at all),
   a price written from the variant map during the ~157-291ms in which Ella's re-render still shows the
   PREVIOUS variant's figure, a guard that stops a Reputon review lightbox from sitting invisibly over the
   page eating taps, and - with the owner's approval, on these 12 products only - suppression of the
   Klaviyo spin-to-win popup that lands on the Non-Slip checkbox mid-selection.
   v6: the add-on checkbox takes the same immediate price path as a select (it used to wait 100-190ms
   for Ella's re-render because the change it forwards is untrusted), and the Reputon guard makes a
   lightbox that has not painted yet pass taps through instead of eating them.
   v7: releases the first-paint reservation pf-cc-form.css v4 keeps for the Shop Pay installments line as
   soon as the component has drawn (see termsReserve). */
(function () {
  'use strict';
  var H = document.documentElement;
  function release() { try { H.classList.remove('pf-cc-hold'); } catch (e) {} }
  if (window.__pfCcForm) { return; }
  if (/(?:^|[?&])pf_cc_off=1(?:&|$)/.test(location.search)) { release(); return; }
  window.__pfCcForm = { version: '7', terms: 0, passes: 0, reconciles: 0, mirrors: 0, provisional: 0, klHidden: 0, repClosed: 0, repWait: 0 };

  var ROOT = '[id^="ProductSection-template--"] .productView-product';
  var HAS = false;
  try { HAS = !!(window.CSS && CSS.supports && CSS.supports('selector(:has(*))')); } catch (e) { HAS = false; }
  var CFG = { startCollapsed: true };

  /*<pure>*/
  var TXT = {
    dcTitle: 'Add cushion details', stRequired: 'Required', stDone: 'All added', stEmail: 'Email your drawing',
    more: 'More', less: 'Less', charts: 'See color charts', chart1: 'See color chart',
    optShow: '+ Add special requests (optional)', optHide: '− Hide special requests',
    optional: ' (optional)', colorPh: 'Cushion color code, piping color code',
    fileNote: 'This file is not sent with your order \u2014 please email it to us after you order.'
  };
  var ERR = {
    'exact size': 'Please enter your exact size.',
    'product thickness': 'Please choose a thickness.',
    'cushion and piping color': 'Please enter your cushion and piping colors.',
    'cushion and piping color / backrest option': 'Please enter your cushion and piping colors.',
    'backrest pieces': 'Please enter how many backrest pieces you need.',
    'custom size drawing': 'Please upload your size drawing.',
    'custom dimensions': 'Please enter width, length and thickness.',
    'color option': 'Please enter your color codes.',
    'personalization': 'Please enter your color or fabric choices.'
  };
  var NO_CONDENSE = { 'backrest pieces': 1 };
  var CHARTS = {
    '10410188734738': [47111946109202, 47111946141970, 47111946174738, 47111946207506, 47136552943890, 47136552976658, 47136553009426, 47136553042194],
    '10410188669202': [47111944339730, 47136566149394, 47136566182162, 47136566214930],
    '10410188964114': [47136557695250, 47136557728018, 47136557760786, 47136557793554, 47136557826322],
    '10410188931346': [47111951712530, 47111951745298, 47111951778066, 47111951810834, 47111951843602, 47111951876370],
    '10410188898578': [47111951253778, 47111951286546, 47111951319314, 47111951352082, 47111951384850, 47111951417618, 47111951450386, 47136559268114, 47136559300882, 47136559333650, 47136559366418, 47136559399186, 47136559431954, 47136559464722],
    '10410188865810': [47136556155154, 47136556187922, 47136556220690, 47136556253458, 47136556286226, 47136556318994, 47136556351762, 47136556384530, 47136556417298],
    '10410188800274': [47111949418770, 47111949451538, 47111949484306, 47111949517074, 47111949549842],
    '10410188767506': [47111948534034, 47111948566802, 47111948599570, 47111948632338, 47136558874898, 47136558907666],
    '10410188701970': [47136556515602, 47136556548370, 47136556581138, 47136556613906, 47136556646674, 47136556679442, 47136556712210],
    '10410188636434': [47136564019474, 47136564052242, 47136564085010, 47136564117778],
    '10410188570898': [47111940407570],
    '10410188538130': 'from2'
  };

  function clean(t) { return String(t == null ? '' : t).replace(/\(unavailable\)/i, '').trim(); }
  function errMsg(prop) {
    var key = String(prop || '').trim().toLowerCase();
    return ERR[key] || ('Please fill in ' + String(prop || '').trim() + '.');
  }
  function fieldKind(prop) {
    return /colou?r/i.test(prop) ? 'color' : (/exact size/i.test(prop) ? 'size' : 'other');
  }
  function splitHelp(text) {
    var lines = String(text || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
    if (lines.length === 1 && (lines[0].length > 70 || /\s(ex|e\.g\.)\s*[:.,]/i.test(lines[0]))) {
      var parts = [];
      var s = lines[0];
      var m = s.match(/^(.*?)\s+((?:ex|e\.g\.)\s*[:.,].*)$/i);
      if (m) { parts.push(m[1]); s = m[2]; }
      var p = s.match(/^(.*?)\s+(\([^()]*\))$/);
      if (p) { parts.push(p[1], p[2]); } else { parts.push(s); }
      if (parts.length === 1) {
        var i = s.indexOf('. ');
        if (i > 0 && i < s.length - 2) { parts = [s.slice(0, i + 1), s.slice(i + 2)]; }
      }
      lines = parts.map(function (x) { return x.trim(); }).filter(Boolean);
    }
    return lines;
  }
  function classifyLine(line) {
    if (/^\(?\s*(ex|e\.g\.?|example)\s*[:.,]/i.test(line) || /^[A-Za-z][A-Za-z ]{2,24}:\s*\S/.test(line)) { return 'example'; }
    if (/^required\b/i.test(line) || /^select up to \d+ files?\.?$/i.test(line)) { return 'drop'; }
    if (/^\(.*\)\.?$/.test(line) || /^[•\-]/.test(line)) { return 'aside'; }
    return 'visible';
  }
  /* o: {kind, isTextarea, hasPlaceholder, sizeDynamic} -> {lines:[{t,c}], placeholder, sizePh, more} */
  function planHelp(text, o) {
    var lines = splitHelp(text).map(function (t, i) { return { t: t, c: i === 0 ? 'visible' : classifyLine(t) }; });
    var ex = lines.filter(function (l) { return l.c === 'example'; });
    var res = { lines: lines, placeholder: null, sizePh: false, more: false };
    var conveyed = false; /* the example lines ended up in the placeholder, so hiding them loses nothing */
    function showExamples() { ex.forEach(function (l) { l.c = 'visible'; }); }
    if (o.isTextarea && !o.hasPlaceholder) {
      if (o.kind === 'size' && o.sizeDynamic) {
        res.sizePh = true;
      } else if (ex.length) {
        var joined = ex.map(function (l) {
          var v = l.t.replace(/^\(?\s*(ex|e\.g\.?|example)\s*[:.,]?\s*/i, '');
          if (/^\(/.test(l.t)) { v = v.replace(/\)\.?$/, ''); }
          return v.trim();
        }).join(', ');
        if (/_{2,}/.test(joined)) {
          if (o.kind === 'color') { res.placeholder = TXT.colorPh; } else { showExamples(); }
        } else if (joined.length <= 90) {
          res.placeholder = 'e.g. ' + joined;
          conveyed = true;
        } else {
          showExamples();
        }
      } else if (o.kind === 'color') {
        res.placeholder = TXT.colorPh;
      }
    } else {
      showExamples();
    }
    /* asides always get a More; examples only when the placeholder did not absorb them
       (dynamic size placeholder, or the '___' colour fallback) - otherwise the merchant's
       own example would render nowhere at all. */
    res.more = lines.some(function (l) { return l.c === 'aside'; }) ||
      (!conveyed && lines.some(function (l) { return l.c === 'example'; }));
    return res;
  }
  function numFrom(t) {
    t = clean(t);
    var m = t.match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/);
    if (m) { return Math.floor((parseFloat(m[1]) + parseFloat(m[2])) / 2); }
    m = t.match(/\d+(?:\.\d+)?/);
    return m ? Math.round(parseFloat(m[0])) : null;
  }
  function sizePlaceholder(a, b) {
    if (a == null || b == null) { return null; }
    return 'e.g. ' + a + '"x' + b + '" - ' + Math.round(a * 2.54) + 'x' + Math.round(b * 2.54) + ' cm';
  }
  function addonPrice(t) {
    var m = String(t || '').match(/\+\s*\$\s*([\d,]+(?:\.\d{1,2})?)/);
    return m ? '+$' + Number(m[1].replace(/,/g, '')).toFixed(2) : '';
  }
  function yesNoTexts(a, b) {
    a = clean(a); b = clean(b);
    if (/^yes\b/i.test(a) && /^no\b/i.test(b)) { return 0; }
    if (/^no\b/i.test(a) && /^yes\b/i.test(b)) { return 1; }
    return -1;
  }
  /*</pure>*/

  var st = { autoOpened: false, userClosed: false, optUser: false, showErr: false, failed: false };
  var mo = null, moT = [], moTimer = 0, chartMemo = null;
  var pmo = null, pmoT = null, rc = { timer: 0, id: '', n: 0, last: 0, busy: false, map: undefined };
  /* px: a price this file wrote from the variant map while Ella's re-render is still in flight - see
     "provisional price" below. px.id is the variant that price belongs to. */
  var px = { id: '', t: 0 };
  var bodyMo = null, bodyTimer = 0;

  function guard(fn) {
    return function () {
      if (st.failed) { return; }
      try { return fn.apply(this, arguments); } catch (e) { failOpen(e); }
    };
  }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function kids(el, cls) { return el ? Array.prototype.filter.call(el.children, function (c) { return c.classList.contains(cls); }) : []; }
  function bb() { return document.querySelector(ROOT); }
  function persoOf(b) { return b ? b.querySelector('.pf-perso[data-pf-perso]') : null; }
  function fieldsOf(p) { return kids(p, 'pf-perso-field'); }
  function inputOf(f) { return f ? f.querySelector('.pf-perso-input') : null; }
  function isEmpty(el) {
    if (el.hasAttribute('data-pf-file')) { return !(el.files && el.files[0]) && !el.value; }
    return !String(el.value || '').trim();
  }
  function missing() {
    return $$('[data-pf-perso] .pf-perso-input[data-pf-required="1"]').filter(isEmpty);
  }
  function errVisible(p) { return !!(p && p.querySelector('.pf-perso-error[style*="block"]')); }
  function dcOf(p) { var d = p && p.previousElementSibling; return d && d.classList.contains('pf-dc') ? d : null; }
  function productId() {
    var f = document.querySelector('[id^="ProductSection-template--"] form[data-type="add-to-cart-form"][id^="product-form-"]') ||
      document.querySelector('form[data-type="add-to-cart-form"][id^="product-form-"]');
    /* form.id would return the form's <input name="id">, so read the attribute */
    var id = f ? String(f.getAttribute('id') || '').replace(/\D+/g, '') : '';
    if (id) { return id; }
    try { return String(window.ShopifyAnalytics.meta.product.id); } catch (e) { return ''; }
  }
  function yesNo(sel) {
    if (!sel || !sel.options || sel.options.length !== 2) { return null; }
    var a = sel.options[0], b = sel.options[1], r = yesNoTexts(a.textContent, b.textContent);
    if (r === 0) { return { yes: a, no: b }; }
    if (r === 1) { return { yes: b, no: a }; }
    return null;
  }
  function selText(s) { var o = s && s.options[s.selectedIndex]; return o ? o.textContent : ''; }
  function sizeSelects() {
    var b = bb(), vs = b && b.querySelector('variant-selects');
    return vs ? $$('select', vs).filter(function (s) { return !yesNo(s); }).slice(0, 2) : [];
  }
  function refreshSizePlaceholder(input) {
    var ss = sizeSelects();
    if (ss.length < 2) { return; }
    var ph = sizePlaceholder(numFrom(selText(ss[0])), numFrom(selText(ss[1])));
    if (ph && input.getAttribute('placeholder') !== ph) { input.setAttribute('placeholder', ph); }
  }
  function refreshAllSizePh(b) { $$('textarea[data-pf-ph="size"]', b).forEach(refreshSizePlaceholder); }
  function grow(ta) {
    ta.style.height = 'auto';
    var sh = ta.scrollHeight + 2;
    ta.style.height = Math.max(64, Math.min(sh, 200)) + 'px';
    ta.style.overflowY = sh > 200 ? 'auto' : 'hidden';
  }
  function updateCount(ta) {
    var f = ta.closest('.pf-perso-field'), c = f && kids(f, 'pf-count')[0];
    if (c && ta.maxLength > 0) {
      var t = ta.value.length + '/' + ta.maxLength;
      if (c.textContent !== t) { c.textContent = t; }
    }
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) { e.className = cls; }
    if (text != null) { e.textContent = text; }
    return e;
  }

  /* ---------------------------------------------------------------- options */
  function stripColon(w) {
    var lab = w.querySelector('.form__label');
    if (!lab) { return; }
    var tw = document.createTreeWalker(lab, NodeFilter.SHOW_TEXT, null), n;
    while ((n = tw.nextNode())) {
      if (n.nodeValue.trim()) {
        if (/\s*:\s*$/.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/\s*:\s*$/, ' '); }
        return;
      }
    }
  }
  function rowFor(b, sel) {
    var rows = $$('.pf-addon', b);
    for (var i = 0; i < rows.length; i++) { if (rows[i].__pfSel === sel) { return rows[i]; } }
    return null;
  }
  function buildAddon(vs, sel, w) {
    var yn = yesNo(sel);
    if (!yn) { return; }
    var m = (sel.getAttribute('name') || '').match(/^options\[(.+)\]$/);
    var lab = w.querySelector('.form__label');
    var name = m ? m[1] : clean(lab ? lab.textContent.replace(/:.*$/, '') : '');
    var price = addonPrice(yn.yes.textContent);
    var row = el('div', 'pf-addon');
    row.setAttribute('data-pf-addon-for', sel.id || '');
    row.__pfSel = sel;
    var label = el('label', 'pf-addon__label');
    var box = el('input', 'pf-addon__box');
    box.type = 'checkbox';
    label.appendChild(box);
    label.appendChild(el('span', 'pf-addon__name', name));
    if (price) { label.appendChild(el('span', 'pf-addon__price', price)); }
    row.appendChild(label);
    var after = vs, nx = vs.nextElementSibling;
    while (nx && nx.classList.contains('pf-addon')) { after = nx; nx = nx.nextElementSibling; }
    after.parentNode.insertBefore(row, after.nextSibling);
    box.checked = sel.value === yn.yes.value;
    box.addEventListener('change', guard(function (e) {
      e.stopPropagation();
      var y = yesNo(sel);
      if (!y) { return; }
      var v = box.checked ? y.yes.value : y.no.value;
      if (sel.value !== v) {
        sel.value = v;
        /* A script-dispatched event is never isTrusted, so onChange() used to treat the shopper's own
           tick as a repair event and skip the immediate price - measured 190ms of the previous
           variant's figure on Linen's Non-Slip box. st.addon marks this forward as the shopper's. */
        st.addon = true;
        try { sel.dispatchEvent(new Event('change', { bubbles: true })); } finally { st.addon = false; }
      }
      onUserOptionChange(name, box.checked);
    }));
  }
  function enhanceOptions(b) {
    var vs = b.querySelector('variant-selects');
    if (!vs) { return; }
    kids(vs, 'product-form__input').forEach(function (w) {
      stripColon(w);
      var sel = w.querySelector('select');
      if (sel && yesNo(sel)) {
        if (!rowFor(b, sel)) { buildAddon(vs, sel, w); }
        if (!w.classList.contains('pf-addon-src')) {
          w.classList.add('pf-addon-src');
          w.setAttribute('data-pf-enhanced', 'addon');
        }
      }
    });
    /* colour picked from a variant select (Kids Corner Sofa): chart link under the options */
    var colorField = $$('[data-pf-perso] .pf-perso-input', b).some(function (i) { return /colou?r/i.test(i.getAttribute('data-pf-prop') || ''); });
    var colorSelect = $$('select', vs).some(function (s) { return /colou?r/i.test(s.getAttribute('name') || ''); });
    if (!colorField && colorSelect && !kids(vs.parentNode, 'pf-opt-actions').length) {
      var list = chartList();
      if (list.length) {
        var box = el('div', 'pf-opt-actions');
        var btn = el('button', 'pf-chart-link', list.length === 1 ? TXT.chart1 : TXT.charts);
        btn.type = 'button';
        box.appendChild(btn);
        var after = vs, nx = vs.nextElementSibling;
        while (nx && nx.classList.contains('pf-addon')) { after = nx; nx = nx.nextElementSibling; }
        after.parentNode.insertBefore(box, after.nextSibling);
      }
    }
  }
  function syncAddons(b) {
    $$('.pf-addon', b).forEach(function (row) {
      var sel = row.__pfSel;
      if (!sel || !sel.isConnected || !b.contains(sel)) {
        row.parentNode.removeChild(row);
        $$('.pf-addon-src', b).forEach(function (w) { if (!w.querySelector('select') || !rowFor(b, w.querySelector('select'))) { w.classList.remove('pf-addon-src'); } });
        return;
      }
      var y = yesNo(sel), box = row.querySelector('.pf-addon__box');
      if (y && box) { box.checked = sel.value === y.yes.value; }
    });
  }

  /* ---------------------------------------------------------------- personalization */
  function ensureActions(f, help, input) {
    var a = kids(f, 'pf-help-actions')[0];
    if (a) { return a; }
    a = el('div', 'pf-help-actions');
    if (help && help.parentNode === f) { f.insertBefore(a, help.nextSibling); } else { f.insertBefore(a, input); }
    return a;
  }
  function condenseHelp(f, input, help, kind) {
    var isTA = input.tagName === 'TEXTAREA';
    var plan = planHelp(help.textContent, {
      kind: kind, isTextarea: isTA, hasPlaceholder: !!input.getAttribute('placeholder'),
      sizeDynamic: kind === 'size' && sizeSelects().length >= 2
    });
    if (plan.sizePh) {
      input.setAttribute('data-pf-ph', 'size');
      refreshSizePlaceholder(input);
    } else if (plan.placeholder) {
      input.setAttribute('placeholder', plan.placeholder);
    }
    if (!help.id) { help.id = 'pf-help-' + (input.id || String(Math.random()).slice(2)); }
    var hidden = false;
    help.textContent = '';
    plan.lines.forEach(function (l) {
      var off = l.c !== 'visible';
      if (off) { hidden = true; }
      help.appendChild(el('span', 'pf-help-line' + (off ? ' pf-help-hidden' : ''), l.t));
    });
    help.classList.add('pf-help', 'is-built');
    if (hidden) { help.classList.add('is-clamped'); }
    if (plan.more) {
      var acts = ensureActions(f, help, input);
      var more = el('button', 'pf-help-more', TXT.more);
      more.type = 'button';
      more.setAttribute('aria-expanded', 'false');
      more.setAttribute('aria-controls', help.id);
      acts.appendChild(more);
    }
  }
  function chartList() {
    if (chartMemo && chartMemo.length) { return chartMemo; }
    var nav = document.querySelector('[id^="ProductSection-template--"] .productView-nav');
    if (!nav) { return []; }
    var conts = $$('.productView-image:not(.slick-cloned) .productView-img-container[data-media-id]', nav);
    var byId = {};
    conts.forEach(function (c) { var id = String(c.getAttribute('data-media-id') || '').split('-').pop(); if (!byId[id]) { byId[id] = c; } });
    var cfg = CHARTS[productId()], pick = [];
    if (cfg === 'from2') { pick = conts.slice(1); } else if (cfg && cfg.length) { pick = cfg.map(function (id) { return byId[String(id)]; }).filter(Boolean); }
    if (!pick.length) {
      pick = conts.filter(function (c) { var im = c.querySelector('img'); return im && /colou?r\s*chart|kartela|swatch|palette/i.test(im.getAttribute('alt') || ''); });
    }
    var out = [];
    pick.forEach(function (c) {
      var a = c.querySelector('[data-fancybox]'), href = a && (a.getAttribute('href') || a.getAttribute('data-src'));
      if (!href) { return; }
      var im = c.querySelector('img'), slide = c.closest('.productView-image');
      var idx = parseInt(slide ? slide.getAttribute('data-slick-index') : '', 10);
      if (isNaN(idx)) { idx = parseInt(slide ? slide.getAttribute('data-index') : '', 10) - 1; }
      var thumb = im ? (im.getAttribute('data-src') || im.currentSrc || im.src || '') : '';
      out.push({ el: c, href: href, thumb: thumb.replace('{width}', '240'), index: isNaN(idx) || idx < 0 ? 0 : idx });
    });
    if (out.length) { chartMemo = out; }
    return out;
  }
  function openCharts() {
    var list = chartList();
    if (!list.length) { return; }
    var jq = window.jQuery;
    if (jq && jq.fancybox && typeof jq.fancybox.open === 'function') {
      jq.fancybox.open(list.map(function (x) { return { src: x.href, type: 'image', opts: { thumb: x.thumb } }; }), { loop: true, hash: false, backFocus: true }, 0);
      return;
    }
    var nav = document.querySelector('[id^="ProductSection-template--"] .productView-nav');
    if (!nav) { return; }
    if (jq && jq(nav).hasClass('slick-initialized')) { try { jq(nav).slick('slickGoTo', list[0].index, true); } catch (e) {} }
    nav.scrollIntoView({ block: 'center' });
  }
  function addChartLink(f, help, input) {
    if (f.querySelector('.pf-chart-link')) { return; }
    var list = chartList();
    if (!list.length) { return; }
    var btn = el('button', 'pf-chart-link', list.length === 1 ? TXT.chart1 : TXT.charts);
    btn.type = 'button';
    ensureActions(f, help, input).appendChild(btn);
  }
  function enhanceField(f) {
    var input = inputOf(f);
    if (!input) { return; }
    var label = f.querySelector(':scope>label');
    var help = label && label.nextElementSibling;
    if (help && (help.tagName !== 'P' || help.classList.contains('pf-perso-error'))) { help = null; }
    var prop = (input.getAttribute('data-pf-prop') || '').trim();
    var key = prop.toLowerCase();
    var wantsChart = fieldKind(prop) === 'color' || (key === 'personalization' && !!help && /colou?r|fabric/i.test(help.textContent));
    if (f.hasAttribute('data-pf-enhanced')) {
      /* retry only the chart link (the gallery may not have been parsed on the first pass) */
      if (wantsChart) { addChartLink(f, help, input); }
      return;
    }
    var required = input.getAttribute('data-pf-required') === '1';
    var err = f.querySelector(':scope>.pf-perso-error');
    if (label) {
      $$('span', label).forEach(function (s) { if (s.textContent.trim() === '*') { s.classList.add('pf-req-star'); } });
    }
    if (!required) {
      f.classList.add('pf-field--optional');
      if (label && !label.querySelector('.pf-opt')) { label.appendChild(el('span', 'pf-opt', TXT.optional)); }
    }
    if (err && !err.hasAttribute('data-pf-msg')) {
      err.textContent = errMsg(prop);
      err.setAttribute('data-pf-msg', '1');
    }
    var kind = fieldKind(prop);
    if (help && !NO_CONDENSE[key]) { condenseHelp(f, input, help, kind); }
    if (input.tagName === 'TEXTAREA') {
      if (input.maxLength > 0 && !kids(f, 'pf-count').length) {
        var c = el('span', 'pf-count', input.value.length + '/' + input.maxLength);
        c.setAttribute('aria-hidden', 'true');
        f.appendChild(c);
        f.classList.add('pf-has-count');
      }
      input.classList.add('pf-autogrow');
      grow(input);
    }
    if (input.hasAttribute('data-pf-file') && !linked(input) && !kids(f, 'pf-file-note').length) {
      /* only reached when the form= link could not be made: then the file really cannot travel with the
         order, so say so in the field rather than letting the details row imply it was captured. */
      var note = el('p', 'pf-file-note', TXT.fileNote);
      if (err) { f.insertBefore(note, err); } else { f.appendChild(note); }
    }
    if (wantsChart) { addChartLink(f, help, input); }
    f.setAttribute('data-pf-enhanced', '1');
  }
  function setOptToggle(tg, open) {
    tg.setAttribute('aria-expanded', String(open));
    var t = open ? TXT.optHide : TXT.optShow;
    if (tg.textContent !== t) { tg.textContent = t; }
  }
  function setOpen(p, open) {
    p.classList.toggle('is-collapsed', !open);
    var dc = dcOf(p);
    if (dc) { dc.setAttribute('aria-expanded', String(open)); }
    if (open) { $$('textarea.pf-autogrow', p).forEach(grow); }
    updateStatus();
  }
  function enhancePerso(b) {
    var p = persoOf(b), fields = fieldsOf(p);
    if (!p || !fields.length) { return; }
    fields.forEach(enhanceField);
    var req = [], opt = [];
    fields.forEach(function (f) { var i = inputOf(f); if (i) { (i.getAttribute('data-pf-required') === '1' ? req : opt).push(f); } });
    if (HAS && req.length && opt.length && !kids(p, 'pf-opt-toggle').length) {
      var tg = el('button', 'pf-opt-toggle');
      tg.type = 'button';
      if (!p.id) { p.id = 'pf-perso-body'; }
      tg.setAttribute('aria-controls', p.id);
      p.insertBefore(tg, opt[0]);
      var anyOpt = opt.some(function (f) { var i = inputOf(f); return i && !isEmpty(i); });
      if (!anyOpt) { p.classList.add('pf-opt-collapsed'); }
      setOptToggle(tg, anyOpt);
    }
    if (HAS && fields.length >= 2 && !dcOf(p)) {
      if (!p.id) { p.id = 'pf-perso-body'; }
      var dc = el('button', 'pf-dc');
      dc.type = 'button';
      dc.setAttribute('aria-expanded', 'false');
      dc.setAttribute('aria-controls', p.id);
      var ic = el('span', 'pf-dc__icon');
      ic.setAttribute('aria-hidden', 'true');
      dc.appendChild(ic);
      dc.appendChild(el('span', 'pf-dc__title', TXT.dcTitle));
      var sts = el('span', 'pf-dc__status');
      sts.setAttribute('aria-live', 'polite');
      dc.appendChild(sts);
      p.parentNode.insertBefore(dc, p);
      var anyValue = fields.some(function (f) { var i = inputOf(f); return i && !isEmpty(i); });
      setOpen(p, !(CFG.startCollapsed && !anyValue && !errVisible(p)));
    }
    if (errVisible(p) && p.classList.contains('is-collapsed')) { setOpen(p, true); }
    restoreState(p, fields);
    p.classList.add('pf-dc-ready');
    release();
  }
  /* the browser can restore typed values (back/forward) after the first pass: open what holds a value, refresh counters */
  function restoreState(p, fields) {
    var filled = function (f) { var i = inputOf(f); return !!i && !isEmpty(i); };
    if (dcOf(p) && p.classList.contains('is-collapsed') && !st.autoOpened && !st.userClosed && fields.some(filled)) {
      st.autoOpened = true;
      setOpen(p, true);
    }
    if (p.classList.contains('pf-opt-collapsed') && !st.optUser && fields.some(function (f) { return f.classList.contains('pf-field--optional') && filled(f); })) {
      p.classList.remove('pf-opt-collapsed');
      var tg = kids(p, 'pf-opt-toggle')[0];
      if (tg) { setOptToggle(tg, true); }
    }
    $$('textarea.pf-perso-input', p).forEach(function (ta) {
      updateCount(ta);
      if (ta.classList.contains('pf-autogrow') && ta.__pfLen !== ta.value.length && !p.classList.contains('is-collapsed')) {
        ta.__pfLen = ta.value.length;
        grow(ta);
      }
    });
  }
  function updateStatus() {
    var p = persoOf(bb()), dc = dcOf(p);
    if (!dc) { return; }
    var s = dc.querySelector('.pf-dc__status');
    if (!s) { return; }
    var req = $$('.pf-perso-input[data-pf-required="1"]', p), r = req.length;
    var n = req.filter(function (i) { return !isEmpty(i); }).length;
    var txt = '', extra = '';
    if (r === 0) { txt = ''; }
    else if (st.showErr && n < r) { txt = 'Please complete ' + (r - n) + ' detail' + (r - n === 1 ? '' : 's'); extra = 'has-error'; }
    else if (n === 0) { txt = TXT.stRequired; }
    else if (n < r) { txt = n + ' of ' + r + ' added'; }
    else {
      /* 'All added' is only true if an attached file can actually travel with the order */
      var undeliv = req.filter(function (i) { return i.hasAttribute('data-pf-file') && !linked(i); }).length;
      txt = undeliv ? TXT.stEmail : TXT.stDone;
      extra = undeliv ? '' : 'is-done';
      st.showErr = false;
    }
    var cls = 'pf-dc__status' + (extra ? ' ' + extra : '');
    if (s.textContent !== txt) { s.textContent = txt; }
    if (s.className !== cls) { s.className = cls; }
  }

  /* ---------------------------------------------------------------- events */
  function onAddCapture(e) {
    var t = e.target;
    var btn = t && t.closest && t.closest('button[name="add"], button[type="submit"]');
    var form = btn && btn.closest('form[data-type="add-to-cart-form"]');
    if (!form) { return; }
    /* capture phase, so this lands before Ella builds its FormData: hand the file field to the form
       that is actually being submitted (main or sticky) */
    pointFilesAt(willRoute(form) ? null : form);
    var p = persoOf(bb());
    if (!p || !missing().length) { return; }
    release();
    if (p.classList.contains('is-collapsed')) { setOpen(p, true); }
    st.showErr = true;
    updateStatus();
    /* never preventDefault/stopPropagation: the colorcode validator blocks, scrolls and focuses */
  }
  function onUiClick(e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var dc = t.closest('.pf-dc');
    if (dc) {
      var p = dc.nextElementSibling;
      if (!p || !p.classList.contains('pf-perso')) { return; }
      var open = dc.getAttribute('aria-expanded') === 'true';
      if (open && errVisible(p)) {
        var bad = p.querySelector('.pf-perso-error[style*="block"]');
        var inp = bad && inputOf(bad.closest('.pf-perso-field'));
        if (inp) { inp.focus(); }
        dc.classList.add('is-nudge'); /* the row stays open on purpose - show the click landed */
        setTimeout(function () { dc.classList.remove('is-nudge'); }, 400);
        return;
      }
      setOpen(p, !open);
      if (open) { st.userClosed = true; }
      return;
    }
    var tg = t.closest('.pf-opt-toggle');
    if (tg) {
      var pp = tg.parentNode;
      var collapsed = pp.classList.toggle('pf-opt-collapsed');
      st.optUser = true;
      setOptToggle(tg, !collapsed);
      if (!collapsed) { $$('textarea.pf-autogrow', pp).forEach(grow); }
      return;
    }
    var more = t.closest('.pf-help-more');
    if (more) {
      var help = document.getElementById(more.getAttribute('aria-controls'));
      if (!help) { return; }
      var clamped = help.classList.toggle('is-clamped');
      more.setAttribute('aria-expanded', String(!clamped));
      more.textContent = clamped ? TXT.more : TXT.less;
      return;
    }
    if (t.closest('.pf-chart-link')) { openCharts(); }
  }
  function onChange(e) {
    var t = e.target, b = bb();
    if (!t || !b) { return; }
    if (t.tagName === 'SELECT') {
      var vs = b.querySelector('variant-selects');
      if (vs && vs.contains(t)) {
        syncAddons(b);
        refreshAllSizePh(b);
        if (!rc.busy) { rc.n = 0; rc.id = ''; }
        /* only for a change the shopper actually made: rc.busy marks reconcile()'s own repair event,
           which re-sends an unchanged selection and must not restate a price */
        if ((e.isTrusted || st.addon) && !rc.busy) { try { provisionalPrice(); } catch (err) {} mirrorSticky(); }
        scheduleReconcile();
        if (e.isTrusted) { onUserOptionChange(null, false); }
        return;
      }
    }
    if (t.classList && t.classList.contains('pf-perso-input')) {
      if (t.tagName === 'TEXTAREA') { updateCount(t); }
      updateStatus();
    }
  }
  function onInput(e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('pf-perso-input')) { return; }
    if (t.tagName === 'TEXTAREA') { grow(t); updateCount(t); }
    updateStatus();
  }
  function onUserOptionChange(name, checked) {
    var p = persoOf(bb());
    if (!p) { return; }
    if (!st.autoOpened && !st.userClosed && p.classList.contains('is-collapsed')) {
      st.autoOpened = true;
      setOpen(p, true);
    }
    if (checked && name) {
      var w = String(name).split(/\s+/)[0].toLowerCase();
      var hit = w && $$('.pf-field--optional', p).some(function (f) {
        var l = f.querySelector(':scope>label');
        return l && l.textContent.toLowerCase().indexOf(w) !== -1;
      });
      if (hit) {
        p.classList.remove('pf-opt-collapsed');
        var tg = kids(p, 'pf-opt-toggle')[0];
        if (tg) { setOptToggle(tg, true); }
        $$('textarea.pf-autogrow', p).forEach(grow);
      }
    }
  }

  /* ---------------------------------------------------------------- price reconcile
     Ella's renderProductAjaxInfo() writes every section reply it receives, even a late reply for a variant
     that is no longer selected (a quick No -> Yes toggle). When the price shown in the buy box disagrees with
     the variant in the cart form, re-send a change event from a variant select - the same event a manual pick
     sends - so colorcode and Ella write the selected variant's price again. Never writes a price itself.
     USD-formatted prices only, at most 4 retries per selected variant. */
  function mainForm() {
    return document.querySelector('[id^="ProductSection-template--"] form[data-type="add-to-cart-form"][id^="product-form-"]:not([id^="product-form-sticky"])') ||
      document.querySelector('form[data-type="add-to-cart-form"][id^="product-form-"]:not([id^="product-form-sticky"])');
  }
  function mapData() {
    if (rc.map !== undefined) { return rc.map; }
    rc.map = null;
    var s = document.querySelector('script[data-pf-variant-map]');
    if (s) {
      try { var o = JSON.parse(s.textContent); if (typeof o === 'string') { o = JSON.parse(o); } if (o && o.m && o.m.length) { rc.map = o; } } catch (e) { rc.map = null; }
    }
    return rc.map;
  }
  function expectedCents(id, vs) {
    var M = mapData(), i;
    if (M) {
      if (M.cur && window.Shopify && Shopify.currency && Shopify.currency.active && String(M.cur).toUpperCase() !== String(Shopify.currency.active).toUpperCase()) { return null; }
      for (i = 0; i < M.m.length; i += 2) { if (String(M.m[i]) === id) { return Number(M.m[i + 1]); } }
    }
    var list = vs && vs.variantData;
    if (!list || !list.length) {
      var js = vs && vs.querySelector('script[type="application/json"]');
      try { list = js ? JSON.parse(js.textContent) : null; } catch (e) { list = null; }
    }
    if (list && list.length) {
      for (i = 0; i < list.length; i++) { if (list[i] && String(list[i].id) === id && typeof list[i].price === 'number') { return list[i].price; } }
    }
    return null;
  }
  /* Ella always renders both a .price__regular and a .price__sale subtree and marks the box
     .price--on-sale when the sale one is the live price. Bailing out on that class disabled the
     reconcile entirely for a discounted cushion; reading .price-item--regular instead would compare
     the cart against the struck-out compare-at price and never settle. So read whichever node is
     actually showing, and fall back to the cents Ella itself wrote into .price__last[data-last]. */
  function shownCents(box) {
    if (!box) { return null; }
    var onSale = !!box.querySelector('.price--on-sale');
    var n = onSale
      ? (box.querySelector('.price__sale .price-item--sale') || box.querySelector('.price-item--sale'))
      : box.querySelector('.price__regular .price-item--regular');
    var t = n ? String(n.textContent || '').trim() : '';
    var m = t.match(/^\$\s?([\d,]+(?:\.\d{2})?)(?:\s*USD)?$/);
    if (m) { return Math.round(parseFloat(m[1].replace(/,/g, '')) * 100); }
    var last = n && n.closest ? n.closest('.price__last') : null;
    var dl = last && last.getAttribute('data-last');
    return dl && /^\d+$/.test(dl) ? Number(dl) : null;
  }
  /* A price check alone cannot see a variant that is wrong at the same price - two option
     combinations often cost the same - so also resolve the selected option values through the very
     map the colorcode block uses, k = ((i1*n2+i2)*n3+i3), and compare that id with the one sitting in
     the cart form. Reads only; the repair stays the same re-dispatched change event. Returns null
     whenever anything is unrecognised, so an unknown shape can never trigger a false mismatch. */
  function idFromOptions(vs) {
    var M = mapData();
    if (!M || !M.o || !M.o.length || !M.v1 || !M.v2 || !M.m || !M.m.length) { return null; }
    var byName = {};
    $$('select', vs).forEach(function (s) {
      var nm = String(s.name || '').replace(/^options\[/, '').replace(/\]$/, '');
      if (nm) { byName[nm] = s.value; }
    });
    var lists = [M.v1, M.v2, M.v3], ix = [], j, i, list, want, at;
    for (j = 0; j < M.o.length; j++) {
      list = lists[j];
      want = byName[M.o[j]];
      if (!list || !list.length || want === undefined) { return null; }
      at = -1;
      for (i = 0; i < list.length; i++) { if (clean(list[i]) === clean(want)) { at = i; break; } }
      if (at < 0) { return null; }
      ix.push(at);
    }
    var n2 = M.v2.length, n3 = (M.v3 && M.v3.length) ? M.v3.length : 1;
    var k = ((ix[0] * n2 + (ix[1] || 0)) * n3 + (ix[2] || 0));
    var id = M.m[2 * k];
    return id ? String(id) : null;
  }
  function scheduleReconcile(ms) {
    clearTimeout(rc.timer);
    rc.timer = setTimeout(reconcile, ms || 350);
  }
  function reconcile() {
    try {
      if (st.failed) { return; }
      mirrorSticky();
      var b = bb(), vs = b && b.querySelector('variant-selects');
      var box = b && b.querySelector('.productView-price');
      var f = mainForm(), idIn = f && f.querySelector('input[name="id"]');
      var id = idIn ? String(idIn.value || '') : '';
      if (!vs || !box || !id) { return; }
      /* A provisional price is written for the variant the shopper just chose, while the cart form still
         holds the previous one. That is a known, transient disagreement - not the late-reply bug this
         function exists to repair - so wait for the form to catch up instead of dispatching a change
         event at a price we wrote ourselves. px.t bounds the wait: if the form never arrives, the guard
         lapses after 4s and the normal audit resumes. */
      if (px.id) {
        if (Date.now() - px.t > 4000) { px.id = ''; setPending(false); }
        else if (id !== px.id) { scheduleReconcile(250); return; }
        else { px.id = ''; setPending(false); }
      }
      if (rc.id !== id) { rc.id = id; rc.n = 0; }
      var want = expectedCents(id, vs), have = shownCents(box);
      var wantId = idFromOptions(vs);
      var idWrong = !!(wantId && wantId !== id);
      var priceWrong = !(want == null || have == null || want === have);
      if (!idWrong && !priceWrong) { return; }
      if (rc.n >= 4) { return; }
      var now = Date.now();
      if (now - rc.last < 700) { scheduleReconcile(700 - (now - rc.last) + 50); return; }
      var sels = $$('select', vs);
      var sel = sels.filter(function (x) { return !!yesNo(x); })[0] || sels[sels.length - 1];
      if (!sel) { return; }
      rc.n++; rc.last = now; window.__pfCcForm.reconciles++;
      rc.busy = true;
      try { sel.dispatchEvent(new Event('change', { bubbles: true })); } finally { rc.busy = false; }
    } catch (e) { try { console.warn('[pf-cc-form] reconcile', e); } catch (x) {} }
  }
  function observePrice(b) {
    if (!window.MutationObserver) { return; }
    var box = b && b.querySelector('.productView-price');
    if (!box || pmoT === box) { return; }
    if (pmo) { pmo.disconnect(); }
    pmo = new MutationObserver(function () { if (!st.failed) { mirrorSticky(); syncTerms(); scheduleReconcile(); } });
    pmo.observe(box, { childList: true, subtree: true, characterData: true });
    pmoT = box;
  }

  /* ---------------------------------------------------------------- sticky-bar price mirror
     assets/pf-sticky-price.js only starts when the page carries a variant map, so on the four products
     without one (Chair, Daybed, Kids Corner Sofa, Fabric by the Yard) the bar kept its page-load price
     while the buy box and the cart moved on. Mirror the rendered buy-box price into the bar, exactly as
     pf-sticky-price.js does for map products. Reads a price, never derives one, and never writes inside
     the buy box; the bar is outside the observed node, so there is no feedback loop. */
  var CARD_SEL = '.productView-stickyCart, .product-item, .card-product, .halo-item, .product-card, product-recommendations, .productView-recently';
  var spBusy = false;
  function buyBoxPriceText(b) {
    var nodes = $$('.price-item--regular, .price__regular .price-item, [data-pf-price]', b);
    for (var i = 0; i < nodes.length; i++) {
      var t = String(nodes[i].textContent || '').trim();
      if (!t || t.charAt(0) !== '$') { continue; }
      if (nodes[i].closest(CARD_SEL)) { continue; }
      return t;
    }
    return null;
  }
  function copyPriceTo(sel, t) {
    if (!t) { return; }
    spBusy = true;
    try {
      $$(sel).forEach(function (n) {
        if (String(n.textContent || '').trim() !== t) { n.textContent = t; window.__pfCcForm.mirrors++; }
      });
    } finally { spBusy = false; }
  }
  /* The bar's own price nodes are in .sticky-left (desktop only) and inside .sticky-product-mobile, the
     panel that carries the 250-truncated picker and is therefore hidden here. On a phone that left the
     bar reading "Add To Cart" and nothing else while the buy box said $1,302.84 - a shopper tapping the
     one button they can see had no idea what it would cost. So the panel stays hidden and a read-only
     name + price goes into the collapsed bar instead. It is built, never cloned: no input, no name
     attribute, outside every cart form, and the price is COPIED from the buy box rather than derived,
     so it cannot disagree with what the cart charges. Desktop already has the theme's own block, so
     pf-cc-form.css hides ours there. */
  function productTitle() {
    var b = bb();
    var n = b && (b.querySelector('.productView-title') || b.querySelector('h1'));
    var t = n ? String(n.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return t;
  }
  function ensureStickyLabel() {
    var bar = stickyBar();
    var host = bar && (bar.querySelector('.sticky-product') || bar.querySelector('.sticky-product-wrapper'));
    if (!host) { return null; }
    var lab = host.querySelector('.pf-sticky-label');
    if (lab && lab.parentNode !== host) { lab = null; }
    if (!lab) {
      lab = el('div', 'pf-sticky-label');
      lab.appendChild(el('span', 'pf-sticky-label__name', productTitle()));
      var pr = el('span', 'pf-sticky-label__price');
      pr.setAttribute('data-pf-sticky-price', '1');
      lab.appendChild(pr);
      host.insertBefore(lab, host.firstChild);
    } else {
      var nm = lab.querySelector('.pf-sticky-label__name'), tt = productTitle();
      if (nm && tt && nm.textContent !== tt) { nm.textContent = tt; }
    }
    return lab;
  }
  function mirrorSticky() {
    if (spBusy || st.failed) { return; }
    var b = bb(), t = b && buyBoxPriceText(b);
    if (!t) { return; }
    /* our own label always, on every product: it is the only price a phone can see */
    copyPriceTo('.productView-stickyCart [data-pf-sticky-price]', t);
    /* the theme's nodes only where pf-sticky-price.js is not already doing it (it starts only when the
       page carries a variant map), so the two never fight over the same node */
    if (mapData()) { return; }
    copyPriceTo('.productView-stickyCart .sticky-price .money-subtotal', t);
  }
  /* mirrorSticky() is gated on st.failed like everything else, so a fail-open used to leave the bar
     showing whatever it last had - on a product without a variant map that is the page-load base
     price, because pf-sticky-price.js only starts when a map is present. Copying a rendered price is
     the one job with no way to make the page worse, so it keeps running after the teardown. */
  function stickyKeeper() {
    if (mapData()) { return; }
    var b0 = bb();
    var box = b0 && b0.querySelector('.productView-price');
    if (!box) { return; }
    function copy() {
      if (spBusy) { return; }
      var t = buyBoxPriceText(bb() || b0);
      if (!t) { return; }
      spBusy = true;
      try {
        $$('.productView-stickyCart .sticky-price .money-subtotal').forEach(function (n) {
          if (String(n.textContent || '').trim() !== t) { n.textContent = t; window.__pfCcForm.mirrors++; }
        });
        /* failOpen() takes our label away with the rest of our UI, so there is nothing of ours to feed
           here - the theme's own nodes are visible again once data-pf-cc is gone. */
      } finally { spBusy = false; }
    }
    copy();
    try { new MutationObserver(copy).observe(box, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    document.addEventListener('change', function (e) {
      var nm = e.target && e.target.name;
      if (nm && nm.indexOf('options[') === 0) { setTimeout(copy, 0); setTimeout(copy, 300); setTimeout(copy, 900); }
    }, true);
  }

  /* ---------------------------------------------------------------- Shop Pay installment terms
     Every cushion page renders two <shopify-payment-terms>: Ella's own (0x0, invisible) and the visible
     pf-buybox one, 16px under the price. Both keep the variant-id the page was rendered with, so the
     financing line never moves while the shopper configures the cushion. Measured on Linen at 412px with
     Width 43-45 / Length 172-175 / Non-Slip Yes: both cart forms correctly held 52634183139602 at
     $1,302.84 while the visible widget still read "Pay in 4 interest-free installments of $14,68" - the
     default variant's figure, 95% short. It reproduces with ?pf_cc_off=1, so it is pre-existing.
     Worse than a stale number: shopify-meta's own financing_plans put $1,000+ in a band whose ONLY terms
     are 15% APR monthly, so interest-free instalments are not an offer that exists at that price at all.
     This file therefore never writes a figure of its own. It hands Shopify's component the true price -
     from the same variant_map that drives the buy box and the cart - and lets the component's own plans
     decide the wording. Measured: price_per_term is ignored by the component entirely (a deliberately
     wrong one rendered identically), everything is derived from full_price, and $1,302.84 renders
     "From $117,59/mo with Shop Pay".
     shopify-meta is truncated at the same 250 variants as the sticky picker, so a configured cushion is
     usually absent from it. When the price is unknown or outside the offer band nothing is injected and
     only the variant-id is corrected, which makes the component fall back to its own generic eligible
     message - never a wrong number. The payload is rebuilt from the pristine data-pf-meta0 every time so
     it cannot grow, and both attributes are restored by failOpen(). */
  function moneyUsd(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function centsOf(v) {
    var m = String(v == null ? '' : v).replace(/[^0-9.,]/g, '').replace(/,/g, '');
    return /^\d+(\.\d{1,2})?$/.test(m) ? Math.round(parseFloat(m) * 100) : null;
  }
  function termsNodes() {
    var pid = productId();
    if (!pid) { return []; }
    return $$('[id^="ProductSection-template--"] shopify-payment-terms').filter(function (n) {
      var f = n.closest('form');
      /* a recommendation card carries another product's widget: ours are the forms named for this product */
      return !!(f && String(f.getAttribute('id') || '').indexOf(pid) >= 0);
    });
  }
  function syncTerms() {
    var f = mainForm(), i = f && f.querySelector('input[name="id"]');
    var id = i && String(i.value || '');
    if (!/^\d+$/.test(id || '')) { return; }
    var b = bb(), vs = b && b.querySelector('variant-selects');
    termsNodes().forEach(function (n) {
      if (n.getAttribute('variant-id') === id) { return; }
      if (!n.hasAttribute('data-pf-terms0')) { n.setAttribute('data-pf-terms0', n.getAttribute('variant-id') || ''); }
      var raw = n.getAttribute('data-pf-meta0') || n.getAttribute('shopify-meta'), meta = null;
      try { meta = JSON.parse(raw); } catch (e) { meta = null; }
      if (meta && meta.variants && meta.variants.length && meta.currency_code === 'USD') {
        if (!n.hasAttribute('data-pf-meta0')) { n.setAttribute('data-pf-meta0', raw); }
        var known = meta.variants.some(function (v) { return String(v.id) === id; });
        var c = known ? null : expectedCents(id, vs);
        var lo = centsOf(meta.min_price), hi = centsOf(meta.max_price);
        if (!known && c != null && lo != null && hi != null && c >= lo && c <= hi) {
          meta.variants = meta.variants.concat([{ id: Number(id), full_price: moneyUsd(c), eligible: true, available: true }]);
          n.setAttribute('shopify-meta', JSON.stringify(meta));
        } else if (n.getAttribute('shopify-meta') !== raw) { n.setAttribute('shopify-meta', raw); }
      }
      n.setAttribute('variant-id', id);
    });
  }
  /* pf-cc-form.css reserves the Shop Pay line's final height from first paint for a US buyer, because the
     component draws its text 0.7-10s after the element is parsed and used to push everything below it down
     50px. Release that reservation once the component has drawn and its text has stopped changing, so the
     line then has its natural height (a later variant change can make it one line instead of two). The
     component can redraw once more right after its first draw (measured: one line, then two lines 140ms
     later), so the release waits until the drawn height has been the same for two checks 250ms apart. On a
     phone the reserved box is never smaller than the drawn line, so waiting costs nothing. If Shop Pay never
     defines the element (blocked script) the box is released 3s after load; in any case after 20s. */
  function termsDrawnHeight(t) {
    var sr = t.shadowRoot, h = 0, c, r;
    if (!sr) { return 0; }
    for (c = sr.firstElementChild; c; c = c.nextElementSibling) {
      if (/^(STYLE|LINK|SCRIPT|TEMPLATE)$/.test(c.nodeName)) { continue; }
      if (!(c.textContent || '').replace(/\s+/g, '').length) { continue; }
      r = c.getBoundingClientRect();
      if (r.height > h) { h = r.height; }
    }
    return Math.round(h);
  }
  function termsReserve() {
    $$('[id^="ProductSection-template--"] .pf-buybox--installments shopify-payment-terms').forEach(function (t) {
      if (t.hasAttribute('data-pf-terms-ready') || t.__pfTermsWatch) { return; }
      t.__pfTermsWatch = true;
      var n = 0, last = -1, same = 0, iv = null, tmo = null;
      var stop = function () { try { if (tmo) { tmo.disconnect(); } } catch (e) {} clearInterval(iv); t.__pfTermsWatch = false; };
      var release = function () { if (!t.hasAttribute('data-pf-terms-ready')) { t.setAttribute('data-pf-terms-ready', '1'); window.__pfCcForm.terms++; } stop(); };
      var check = function () {
        n++;
        if (t.hasAttribute('data-pf-terms-ready') || !t.isConnected) { stop(); return; }
        var h = termsDrawnHeight(t);
        if (h > 0 && h === last) { same++; } else { same = 0; }
        last = h;
        if (h > 0 && same >= 2) { release(); return; }
        if (!tmo && t.shadowRoot && window.MutationObserver) {
          /* a redraw restarts the count at once instead of waiting for the next tick */
          tmo = new MutationObserver(function () { same = 0; });
          tmo.observe(t.shadowRoot, { childList: true, subtree: true, characterData: true });
        }
        var defined = !!(window.customElements && window.customElements.get('shopify-payment-terms'));
        if ((document.readyState === 'complete' && !defined && n >= 12) || n >= 80) { release(); }
      };
      iv = setInterval(function () { try { check(); } catch (e) { release(); } }, 250);
      try { check(); } catch (e) { release(); }
    });
  }
  function restoreTerms() {
    $$('[data-pf-terms0]').forEach(function (n) {
      var m = n.getAttribute('data-pf-meta0');
      if (m !== null) { n.setAttribute('shopify-meta', m); n.removeAttribute('data-pf-meta0'); }
      n.setAttribute('variant-id', n.getAttribute('data-pf-terms0') || '');
      n.removeAttribute('data-pf-terms0');
    });
  }

  /* ---------------------------------------------------------------- sticky bar safety
     Ella builds the sticky bar's pickers from a variant list truncated at Shopify's 250 cap. On Linen
     select#stick-variant-... carries 250 options and not one of them says "Yes", and the mobile panel
     renders "Non-Slip Base" as a single "No" radio. Touching either runs
     variant-sticky-selects.onVariantChange() -> updateMasterId() -> updateVariantInput(), which writes a
     variant the shopper never picked into both cart forms. Measured at 412px on Linen: with Non-Slip Yes
     chosen in the real form (52634124976402, $106.00) one tap on the panel's Width silently moved the cart
     form to the No variant (52625637933330, $58.70) while the buy box still read "Yes (+$35)".
     The express buttons inside the sticky form are the same class of hazard: they post straight to
     checkout, skipping the colorcode validator, so an order could arrive with no size, thickness or
     colour. Neither is caused by this file - both reproduce with ?pf_cc_off=1.
     So on cushion pages the sticky bar keeps only its Add to cart and the hidden id our own form syncs.
     Hide and disable rather than delete, so ?pf_cc_off=1 and failOpen() put the page back unchanged.
     (On Chair the sticky list happens to be complete at 98 variants; the pickers still go, so that the
     shopper always configures in the one form that also carries the personalization fields.) */
  var NEUTER = 'variant-sticky-selects,.sticky-product-mobile,a.sticky-product-expand';
  var NEUTER_PAY = 'shopify-accelerated-checkout,shopify-payment-button,.shopify-payment-button,[data-shopify="payment-button"]';
  function neuter(el, why) {
    if (!el || el.getAttribute('data-pf-off')) { return; }
    el.setAttribute('data-pf-off', why);
    el.setAttribute('aria-hidden', 'true');
    var ctls = $$('select,input,button,textarea,a', el);
    if (/^(SELECT|INPUT|BUTTON|TEXTAREA|A)$/.test(el.tagName)) { ctls.push(el); }
    ctls.forEach(function (c) {
      if (c.getAttribute('data-pf-off-ctl')) { return; }
      /* never touch anything the cart actually submits */
      if (c.name && c.closest('form[data-type="add-to-cart-form"]')) { return; }
      c.setAttribute('data-pf-off-ctl', (c.disabled ? '1' : '0') + '|' + (c.hasAttribute('tabindex') ? c.getAttribute('tabindex') : '-'));
      c.setAttribute('tabindex', '-1');
      try { c.disabled = true; } catch (e) {}
    });
  }
  function sectionRoot() { return document.querySelector('[id^="ProductSection-template--"]'); }
  function stickyBar() { var r = sectionRoot(); return r ? r.querySelector('.productView-stickyCart') : null; }
  function neuterSticky() {
    var bar = stickyBar();
    if (bar) { $$(NEUTER, bar).forEach(function (n) { neuter(n, 'picker'); }); }
    $$('[id^="ProductSection-template--"] form[data-type="add-to-cart-form"]').forEach(function (f) {
      $$(NEUTER_PAY, f).forEach(function (n) { neuter(n, 'express'); });
    });
  }
  function restoreNeutered() {
    $$('[data-pf-off-ctl]').forEach(function (c) {
      var p = String(c.getAttribute('data-pf-off-ctl') || '').split('|');
      try { c.disabled = p[0] === '1'; } catch (e) {}
      if (p[1] === '-') { c.removeAttribute('tabindex'); } else { c.setAttribute('tabindex', p[1]); }
      c.removeAttribute('data-pf-off-ctl');
    });
    $$('[data-pf-off]').forEach(function (n) { n.removeAttribute('data-pf-off'); n.removeAttribute('aria-hidden'); });
  }

  /* ---------------------------------------------------------------- sticky add-to-cart routing
     The main buy box is wrapped in <product-form>, so Ella submits it as new FormData(form) and an
     attached File travels with the line item. The sticky bar's form has no <product-form> ancestor and
     falls back to a urlencoded string body - measured on Trapezoid by instrumenting XMLHttpRequest.send
     before the click: POST /cart/add.js, isFD false, body
     "quantity=1&id=52634100891922&properties[Cushion and Piping Color]=...&properties[Product Thickness]=..."
     with properties[Custom Size Drawing] simply absent. A urlencoded string can never carry a File, so
     form association (which only changes what new FormData(form) would contain) cannot rescue that path:
     the REQUIRED drawing was dropped by the one button a phone shopper actually sees, while the details
     row still read "All added". On a product that has a file field the sticky Add to cart therefore hands
     the click to the main Add to cart - the same path already proven to deliver the file - instead of
     letting Ella serialize the sticky form. The colorcode validator still runs first (it stops the event
     at document capture, so an incomplete form never reaches this listener), both forms already carry the
     same variant id, and exactly one /cart/add.js request is made. A product with no file field keeps
     Ella's own sticky path untouched. */
  function stickyCartForms() {
    var m = mainForm();
    return $$('[id^="ProductSection-template--"] form[data-type="add-to-cart-form"]').filter(function (f) { return f !== m; });
  }
  function willRoute(f) { return !!(f && f.getAttribute && f.getAttribute('data-pf-route')); }
  var routing = false;
  function onStickyAdd(e) {
    var t = e.target;
    var btn = t && t.closest && t.closest('button[name="add"], button[type="submit"]');
    if (!btn) { return; }
    var m = mainForm(), mb = m && m.querySelector('button[name="add"]');
    /* no main button to hand to, or nothing to rescue: leave the theme's own path exactly as it was */
    if (!mb || mb.disabled || !fileFields().length) { return; }
    /* never hand the main button back to itself. mainForm() is resolved again at click time, so if it
       ever returned the very form this listener is bound to, the delegation would recurse forever on a
       money path - cheap insurance against a stale data-pf-route attribute. */
    if (routing || btn === mb || m === btn.closest('form[data-type="add-to-cart-form"]')) { return; }
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    pointFilesAt(m);
    routing = true;
    try { mb.click(); } finally { setTimeout(function () { routing = false; }, 0); }
  }
  var stickyH = function (e) { if (st.failed) { return; } try { onStickyAdd(e); } catch (err) { failOpen(err); } };
  function routeSticky() {
    if (!fileFields().length) { return; }
    stickyCartForms().forEach(function (f) {
      if (f.getAttribute('data-pf-route')) { return; }
      f.setAttribute('data-pf-route', '1');
      f.addEventListener('click', stickyH, true);
    });
  }
  function unrouteSticky() {
    $$('[data-pf-route]').forEach(function (f) {
      try { f.removeEventListener('click', stickyH, true); } catch (e) {}
      f.removeAttribute('data-pf-route');
    });
  }

  /* ---------------------------------------------------------------- required file delivery
     personalization_fields renders the file field inside .pf-perso, a sibling of the cart form, so
     input.form was null and Ella's FormData never carried it: on Trapezoid the REQUIRED "Custom Size
     Drawing" silently never reached the order while the details row still said "All added". The
     colorcode block cannot carry it either - it injects properties as hidden inputs, and a hidden input
     holds strings only, never a File. Both cart forms are already enctype="multipart/form-data", and
     HTML form-association pulls an outside input into FormData from the form= attribute alone (measured
     on Trapezoid: FormData(form).has('properties[Custom Size Drawing]') false -> true, value a File).
     So point the field at the cart form instead of moving it: nothing is reparented, a chosen file is
     never lost, and dropping the attribute restores the page exactly. */
  function fileFields() { return $$('[data-pf-perso] .pf-perso-input[data-pf-file]'); }
  function linked(i) {
    var f = i && i.form;
    return !!(f && f.getAttribute && f.getAttribute('data-type') === 'add-to-cart-form');
  }
  function pointFilesAt(form) {
    var f = form || mainForm();
    var id = f && f.getAttribute('id');
    if (!id) { return; }
    fileFields().forEach(function (i) {
      if (i.closest('form[data-type="add-to-cart-form"]')) { return; }
      if (i.getAttribute('form') !== id) { i.setAttribute('form', id); }
    });
  }
  /* a note added by an earlier pass stops being true once the link is made */
  function syncFileNotes() {
    fileFields().forEach(function (i) {
      if (!linked(i)) { return; }
      var fl = i.closest('.pf-perso-field'), n = fl && kids(fl, 'pf-file-note')[0];
      if (n) { n.parentNode.removeChild(n); }
    });
  }

  /* ---------------------------------------------------------------- provisional price
     Ella re-renders the whole buy box over AJAX on every option change, so between the shopper's tap
     and the reply the price node still shows the PREVIOUS variant. Measured on Linen at 412px, Non-Slip
     No -> Yes: the box read $58.70 for 157ms after the change (the verifier measured 291ms on a slower
     reply) before settling on $93.70. That is not a cosmetic lag - it is a wrong price sitting under the
     shopper's finger at the exact moment they are deciding whether to pay it.
     The number written here is not invented and not estimated: idFromOptions() resolves the chosen
     options through the same variant map the colorcode block uses to fill the cart, and expectedCents()
     reads that variant's price out of the same map. Measured on the change above, the map answered
     52634124943634 / $93.70 synchronously - identical to what Ella rendered 157ms later.
     Guards: only when the map can name the variant AND the currency matches, never on a discounted box
     (the sale / compare-at markup is the theme's to arrange), and never as a substitute for the real
     render - Ella still overwrites it and reconcile() still audits the result. Where the map cannot
     answer, the figure is dimmed instead of replaced, so a stale number is at least visibly unsettled.
     px.id records which variant the written price belongs to, so reconcile() can tell "the cart has not
     caught up yet" apart from "the cart and the price genuinely disagree" and never fires a repair at
     its own handiwork. */
  function priceBox() { var b = bb(); return b && b.querySelector('.productView-price'); }
  function plainPriceNode(box) {
    if (!box || box.querySelector('.price--on-sale')) { return null; }
    return box.querySelector('.price__regular .price-item--regular');
  }
  function setPending(on) {
    var box = priceBox();
    if (box) { box.classList[on ? 'add' : 'remove']('pf-price-pending'); }
  }
  function provisionalPrice() {
    var b = bb(), vs = b && b.querySelector('variant-selects');
    if (!vs || !mapData()) { return; }
    var want = idFromOptions(vs);
    if (!want) { setPending(true); px.t = Date.now(); return; }
    var cents = expectedCents(want, vs), node = plainPriceNode(priceBox());
    if (cents == null || !node) { setPending(true); px.t = Date.now(); return; }
    px.id = want; px.t = Date.now();
    var txt = moneyUsd(cents);
    if (String(node.textContent || '').trim() !== txt) {
      node.textContent = txt;
      window.__pfCcForm.provisional++;
    }
    setPending(false);
  }

  /* ---------------------------------------------------------------- Reputon review lightbox
     Tapping a photo in the Reputon widget builds DIV.reputon-modal - position:fixed, the whole viewport,
     z-index 99999, pointer-events auto - whose only visible layer is a child .reputon-modal-backdrop.
     When that child paints, the lightbox is fine and this file leaves it completely alone (verified on
     Linen: a healthy modal shows a 330x330 loaded photo over a 0.7-opacity black backdrop, and a
     backdrop tap closes it). When it does not, what is left is an invisible full-screen sheet that shows
     nothing and eats the shopper's next tap anywhere on the page.
     Two additions, both defensive, neither touching the app's review data, its network calls or what a
     working lightbox displays:
       1. a tap outside .reputon-modal-content always closes it - which is what the app itself does when
          its backdrop is wired, and the escape hatch when it is not;
       2. if the sheet shows neither a laid-out loaded photo nor a painted backdrop shortly after it
          opens, it is removed, because at that point it can only be in the way.
     Limits: this keys on the semantic class names reputon-modal / -content / -backdrop. The app's other
     class names are build-hashed (go2758897159) and are deliberately not used. If Reputon renames the
     semantic ones, every check below matches nothing and the widget behaves exactly as the app ships it
     - no error, no fallback UI, nothing removed. It also cannot help with a modal that renders nothing
     but keeps a painted backdrop: that reads as healthy here, and is the app's to fix. */
  var REP = '.reputon-modal';
  function repHealthy(m) {
    var ims = m.querySelectorAll('img'), i, r;
    for (i = 0; i < ims.length; i++) {
      r = ims[i].getBoundingClientRect();
      if (ims[i].naturalWidth > 0 && r.width >= 40 && r.height >= 40) { return true; }
    }
    var bd = m.querySelector('.reputon-modal-backdrop');
    if (bd) {
      var c = getComputedStyle(bd), bg = c.backgroundColor || '';
      if (parseFloat(c.opacity) >= 0.1 && bg && bg !== 'transparent' && bg.indexOf(', 0)') < 0) { return true; }
    }
    return false;
  }
  function repOn(m) { try { return !!m && (m.isConnected !== undefined ? m.isConnected : document.documentElement.contains(m)); } catch (e) { return false; } }
  function repClose(m) {
    try { if (m && m.parentNode) { m.parentNode.removeChild(m); window.__pfCcForm.repClosed++; } } catch (e) {}
  }
  /* Removing the node alone leaves the app believing its lightbox is still open - measured: the next
     photo tap rendered nothing at all until a reload. So ask the app to close first, through the same
     backdrop tap it already handles, and remove the node only if the app did not take it away. */
  function repDismiss(m) {
    try { var bd = m.querySelector('.reputon-modal-backdrop'); if (bd) { bd.click(); } } catch (e) {}
    setTimeout(function () { if (repOn(m)) { repClose(m); } else { window.__pfCcForm.repClosed++; } }, 350);
  }
  /* v6. Closing an unhealthy sheet at 400ms still left 400ms in which it swallowed a tap, and the test
     itself could misfire: the backdrop fades in with a 0.2s CSS animation and the photos are laid out by
     a carousel, and neither advances while the page is hidden, so a perfectly good lightbox read as
     "unhealthy" and was removed. Now a sheet that has not painted yet is made pointer-transparent the
     moment it is inserted (data-pf-rep-wait + one CSS rule under html[data-pf-cc]), so a tap reaches the
     page instead of vanishing; it is handed its pointer events back the moment it paints - normally the
     first frame of its fade - and is removed only after 1.5s of VISIBLE time without ever painting.
     Time spent hidden does not count. Any error in the check counts as healthy: the app's own behaviour. */
  function repGuard(m) {
    if (!m || m.getAttribute('data-pf-rep')) { return; }
    m.setAttribute('data-pf-rep', '1');
    /* The app closes on a backdrop tap by itself (verified with ?pf_cc_off=1), so this is only the
       fallback for a backdrop that is not wired: it waits for the app's own handler to run first and
       removes the sheet only if it is still there, so the app's state is never pre-empted. */
    m.addEventListener('click', function (e) {
      if (m.hasAttribute('data-pf-rep-wait')) { return; }
      var t = e.target;
      if (!t || !t.closest || !t.closest('.reputon-modal-content')) {
        setTimeout(function () { if (repOn(m)) { repClose(m); } }, 350);
      }
    }, true);
    var shown = 0, last = Date.now(), waited = false, timer = 0;
    /* background timers can be held back for a long time, so coming back to the tab re-checks at once */
    function onVis() { if (document.visibilityState !== 'hidden') { last = Date.now(); clearTimeout(timer); check(); } }
    function done() { clearTimeout(timer); document.removeEventListener('visibilitychange', onVis); }
    function check() {
      if (!repOn(m)) { done(); return; }
      if (st.failed) { m.removeAttribute('data-pf-rep-wait'); done(); return; }
      var now = Date.now(), vis = document.visibilityState !== 'hidden';
      if (vis) { shown += Math.min(now - last, 250); }
      last = now;
      var ok = true;
      try { ok = repHealthy(m); } catch (e) { ok = true; }
      if (ok) { m.removeAttribute('data-pf-rep-wait'); done(); return; }
      if (!waited) { waited = true; window.__pfCcForm.repWait++; }
      m.setAttribute('data-pf-rep-wait', '1');
      if (shown >= 1500) { done(); repDismiss(m); return; }
      clearTimeout(timer);
      timer = setTimeout(check, vis ? 50 : 500);
    }
    document.addEventListener('visibilitychange', onVis);
    check();
  }

  /* ---------------------------------------------------------------- Klaviyo spin-to-win (owner approved)
     The wheel is a position:fixed, z-index 90000 sheet across the whole viewport; on a phone it lands on
     the Non-Slip checkbox while the shopper is part-way through configuring. The owner approved
     suppressing it on the 12 cushion product pages and only there - this file is loaded only on
     custom-cushion templates, so there is no route by which it can reach any other page.
     It is suppressed narrowly: find a [data-testid="klaviyo-spintowin"] component, walk up to the
     nearest fixed-position ancestor, mark THAT. An embedded signup form is position:static and has no
     spin-to-win child, so it is never marked; any other Klaviyo popup has no spin-to-win child either
     and keeps working. Klaviyo's script, its tracking, identify and every other form are untouched -
     nothing is removed from the DOM and no Klaviyo API is called, so the app's own state stays intact.
     (One consequence worth naming: Klaviyo still counts the form as displayed, so its impression stats
     for this form will include cushion pages where nobody could have seen it.)
     The hiding itself is one CSS rule under html[data-pf-cc], so ?pf_cc_off=1 (where the attribute is
     never written) and failOpen() (where it is removed) both hand the wheel straight back. */
  var KL_SPIN = '[data-testid="klaviyo-spintowin"],.klaviyo-spintowin';
  function klOverlayOf(n) {
    var p = n, i;
    for (i = 0; i < 14 && p && p !== document.body; i++) {
      try { if (getComputedStyle(p).position === 'fixed') { return p; } } catch (e) { return null; }
      p = p.parentElement;
    }
    return null;
  }
  function klSuppress() {
    $$(KL_SPIN).forEach(function (n) {
      var o = klOverlayOf(n);
      if (o && !o.getAttribute('data-pf-kl-off')) {
        o.setAttribute('data-pf-kl-off', 'spintowin');
        window.__pfCcForm.klHidden++;
      }
    });
  }
  function klRestore() {
    $$('[data-pf-kl-off]').forEach(function (n) { n.removeAttribute('data-pf-kl-off'); });
  }

  /* Both of the above are injected by third-party scripts at unpredictable moments and both have to be
     dealt with before the shopper's next tap, so watch the body rather than poll. The scan runs
     synchronously for a batch that plausibly contains one of them (a cheap className test, because the
     slider mutates this subtree constantly and a querySelectorAll per batch would not be free) and is
     debounced otherwise, so a node that arrives some other way is still caught a frame later. */
  function scanOverlays() {
    if (st.failed) { return; }
    try { klSuppress(); } catch (e) {}
    try { $$(REP).forEach(repGuard); } catch (e) {}
  }
  function looksRelevant(x) {
    if (!x || x.nodeType !== 1) { return false; }
    var cn = x.className;
    var c = String(cn && cn.baseVal !== undefined ? cn.baseVal : (cn || ''));
    if (c.indexOf('reputon') >= 0 || c.indexOf('kl-private') >= 0 || c.indexOf('klaviyo') >= 0) { return true; }
    return !!(x.getAttribute && x.getAttribute('data-testid'));
  }
  function watchOverlays() {
    if (bodyMo || !window.MutationObserver || st.failed || !document.body) { return; }
    bodyMo = new MutationObserver(function (recs) {
      if (st.failed) { return; }
      var i, j, a, hot = false;
      for (i = 0; i < recs.length && !hot; i++) {
        a = recs[i].addedNodes;
        for (j = 0; j < a.length; j++) { if (looksRelevant(a[j])) { hot = true; break; } }
      }
      if (hot) { scanOverlays(); return; }
      clearTimeout(bodyTimer);
      bodyTimer = setTimeout(scanOverlays, 120);
    });
    try { bodyMo.observe(document.body, { childList: true, subtree: true }); } catch (e) { bodyMo = null; return; }
    scanOverlays();
  }

  /* ---------------------------------------------------------------- lifecycle */
  function selfCheck(b) {
    function fail(r) { throw new Error('pf-cc selfCheck: ' + r); }
    if ($$('.pf-perso-input').length !== $$('[data-pf-perso] .pf-perso-input').length) { fail('input outside [data-pf-perso]'); }
    $$('[data-pf-perso] .pf-perso-input[data-pf-required="1"]').forEach(function (i) {
      var f = i.closest('.pf-perso-field');
      if (!f || !f.querySelector('.pf-perso-error')) { fail('required field without error node'); }
      if (i.closest('.pf-field--optional')) { fail('required field marked optional'); }
    });
    if (b.querySelectorAll('.pf-dc').length > 1 || document.querySelectorAll('.pf-dc').length > 1) { fail('duplicate details row'); }
    var vs = b.querySelector('variant-selects');
    var yn = vs ? $$('select', vs).filter(function (s) { return !!yesNo(s); }).length : 0;
    if ($$('.pf-addon', b).length !== yn) { fail('add-on rows ' + $$('.pf-addon', b).length + ' != yes/no selects ' + yn); }
    $$('.pf-addon-src', b).forEach(function (w) { var s = w.querySelector('select'); if (!s || !rowFor(b, s)) { fail('hidden option without row'); } });
    $$('.pf-addon,.pf-dc,.pf-opt-toggle,.pf-help-more,.pf-chart-link,.pf-count,.pf-sticky-label').forEach(function (x) {
      if (x.hasAttribute('name') || x.closest('form[data-type="add-to-cart-form"]')) { fail('ui element named or inside a cart form'); }
    });
    /* the bar must never gain a second price that could drift from the buy box */
    if ($$('.productView-stickyCart .pf-sticky-label').length > 1) { fail('duplicate sticky label'); }
    /* neutralising must never silence a field the cart submits */
    $$('[data-pf-off-ctl]').forEach(function (c) {
      if (c.name && c.closest('form[data-type="add-to-cart-form"]')) { fail('disabled a named control inside a cart form'); }
    });
    $$('form[data-type="add-to-cart-form"]').forEach(function (f) {
      if (!f.querySelector('input[name="id"]')) { fail('cart form lost its id input'); }
    });
  }
  function enhanceAll() {
    window.__pfCcForm.passes++;
    var b = bb();
    if (!b) { release(); return; }
    enhanceOptions(b);
    syncAddons(b);
    neuterSticky();
    ensureStickyLabel();
    routeSticky();
    pointFilesAt();
    enhancePerso(b);
    syncFileNotes();
    refreshAllSizePh(b);
    updateStatus();
    mirrorSticky();
    syncTerms();
    watchOverlays();
    selfCheck(b);
    release();
  }
  function observe() {
    if (!window.MutationObserver || st.failed) { return; }
    var b = bb();
    if (!b) { return; }
    var vb = b.querySelector('.productView-moreItem-product-variant'), p = persoOf(b), sk = stickyBar();
    try { observePrice(b); } catch (e) {}
    if (mo && moT[0] === b && moT[1] === vb && moT[2] === p && moT[3] === sk) { return; }
    if (mo) { mo.disconnect(); }
    mo = new MutationObserver(function () {
      if (st.failed) { return; }
      clearTimeout(moTimer);
      moTimer = setTimeout(function () { guard(enhanceAll)(); guard(observe)(); }, 80);
    });
    mo.observe(b, { childList: true });
    if (vb) { mo.observe(vb, { childList: true, subtree: true }); }
    if (p) { mo.observe(p, { childList: true }); }
    /* neuterSticky() and routeSticky() both write to the sticky bar, which lives outside the buy box -
       and every observer above is bound inside the buy box, so nothing watched the node being guarded.
       Measured: replacing .productView-stickyCart with un-neutered markup left off 0 / radios 0 of 36 /
       express buttons display:block at t+0s, t+3s and t+7s, i.e. the truncated variant picker and the
       validation-skipping express buttons came back for good. Watch the PARENT of every node from the
       sticky bar up to the section root - childList only, so a replacement at any level is seen without
       subscribing to the slider's constant subtree churn. */
    var chain = [], root = sectionRoot(), node = sk || root, i;
    for (i = 0; node && i < 16; i++) { chain.push(node); if (node === root) { break; } node = node.parentNode; }
    if (root && chain.indexOf(root) < 0) { chain.push(root); }
    chain.forEach(function (c) {
      var par = c && c.parentNode;
      if (par && par.nodeType === 1) { try { mo.observe(par, { childList: true }); } catch (e) {} }
    });
    moT = [b, vb, p, sk];
  }
  function failOpen(err) {
    if (st.failed) { return; }
    st.failed = true;
    try { window.__pfCcFailed = String((err && err.message) || err); } catch (e) {}
    try { console.warn('[pf-cc-form] fail-open', err); } catch (e) {}
    release();
    try { if (mo) { mo.disconnect(); } clearTimeout(moTimer); if (pmo) { pmo.disconnect(); } clearTimeout(rc.timer); } catch (e) {}
    [['.pf-perso.is-collapsed', 'is-collapsed'], ['.pf-perso.pf-opt-collapsed', 'pf-opt-collapsed'],
      ['.pf-help.is-clamped', 'is-clamped'], ['.pf-addon-src', 'pf-addon-src']].forEach(function (x) {
      try { $$(x[0]).forEach(function (n) { n.classList.remove(x[1]); }); } catch (e) {}
    });
    try { restoreNeutered(); } catch (e) {}
    try { unrouteSticky(); } catch (e) {}
    try { klRestore(); } catch (e) {}
    try { $$('[data-pf-rep-wait]').forEach(function (n) { n.removeAttribute('data-pf-rep-wait'); }); } catch (e) {}
    try { if (bodyMo) { bodyMo.disconnect(); } clearTimeout(bodyTimer); bodyMo = null; } catch (e) {}
    try { setPending(false); px.id = ''; } catch (e) {}
    try { fileFields().forEach(function (i) { i.removeAttribute('form'); }); } catch (e) {}
    try { $$('.pf-addon,.pf-dc,.pf-opt-toggle,.pf-sticky-label').forEach(function (n) { n.parentNode.removeChild(n); }); } catch (e) {}
    try { restoreTerms(); } catch (e) {}
    try { H.removeAttribute('data-pf-cc'); } catch (e) {}
    try { stickyKeeper(); } catch (e) {}
  }

  window.addEventListener('click', guard(onAddCapture), true);
  document.addEventListener('click', guard(onUiClick), false);
  document.addEventListener('change', guard(onChange), false);
  document.addEventListener('input', guard(onInput), false);

  function boot() {
    /* the wheel and the lightbox can both appear before the buy box is even enhanced, so this does not
       wait for enhanceAll()'s first pass */
    try { watchOverlays(); } catch (e) {}
    try { termsReserve(); } catch (e) {}
    guard(enhanceAll)();
    try { observe(); } catch (e) { failOpen(e); }
    setTimeout(guard(enhanceAll), 800);
    setTimeout(guard(enhanceAll), 2500);
    window.addEventListener('load', function () { setTimeout(guard(enhanceAll), 60); });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) { setTimeout(guard(enhanceAll), 60); } });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { guard(enhanceAll)(); guard(observe)(); try { termsReserve(); } catch (e) {} }, 60);
    });
    document.addEventListener('change', function (e) {
      var nm = e.target && e.target.name;
      if (nm && nm.indexOf('options[') === 0) { [0, 400, 1200].forEach(function (ms) { setTimeout(guard(syncTerms), ms); }); }
    }, true);
    scheduleReconcile(3000);
    release();
  }
  window.pfCcForm = {
    version: '9',
    failOpen: function (r) { failOpen(r || 'manual'); },
    openCharts: guard(openCharts),
    syncTerms: guard(syncTerms),
    enhanceAll: guard(enhanceAll),
    scanOverlays: guard(scanOverlays),
    stickyLabel: guard(ensureStickyLabel)
  };
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
